import { render, staticRenderFns } from "./SubjectCategories.vue?vue&type=template&id=5c1c8379&scoped=true&"
import script from "./SubjectCategories.vue?vue&type=script&lang=js&"
export * from "./SubjectCategories.vue?vue&type=script&lang=js&"
import style0 from "./SubjectCategories.vue?vue&type=style&index=0&id=5c1c8379&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1c8379",
  null
  
)

export default component.exports